import {
  Form,
  Input,
  Select,
  Radio,
  Modal,
  ModalProps,
  FormProps,
  InputNumber,
  useSelect,
} from "@pankod/refine-antd";

import { TagTypes } from "interfaces/enums";
import { useState } from "react";
import { normalizeTagValues } from "./normalize";

type Props = {
  modalProps: ModalProps;
  formProps: FormProps;
};

export const TagsCreate: React.FC<Props> = ({ formProps, modalProps }) => {
  const [isSuperCategorySelected, setIsSuperCategorySelected] =
    useState<boolean>(false);

  const { selectProps: superCategorySelectProps } = useSelect({
    resource: "super-category",
    optionLabel: "name",
    optionValue: "id",
  });

  return (
    <Modal {...modalProps} title="Etiket Oluştur" width={400}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.(normalizeTagValues(values))
        }
        initialValues={{
          isActive: true,
        }}
      >
        <Form.Item
          label="Etiket Adı"
          name="name"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Etiket adı boş olamaz.",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Açıklama"
          name="description"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Etiket açıklaması boş olamaz.",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Süper Kategori (2. seviye)"
          name={["superCategory", "id"]}
          validateTrigger="onBlur"
        >
          <Select
            {...superCategorySelectProps}
            allowClear
            placeholder="Süper Kategori Seçin"
            onChange={(value) => setIsSuperCategorySelected(!!value)}
          />
        </Form.Item>

        {isSuperCategorySelected && (
          <Form.Item
            label="Süper Kategori Gösterim Sırası"
            name="superCategoryOrder"
            validateTrigger="onBlur"
            extra="Boş bırakılırsa etiket, sırası olanların ardından listelenir."
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        )}

        <Form.Item
          label="Etiket Tipi"
          name="type"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: "Etiket tipi boş olamaz.",
            },
          ]}
        >
          <Select
            options={[
              {
                value: TagTypes.ASSET,
                label: "Asset",
              },
              {
                value: TagTypes.TEMPLATE,
                label: "Template",
              },
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Durumu"
          name="isActive"
          rules={[
            {
              required: true,
              message: "Etiket durumunu seçiniz.",
            },
          ]}
        >
          <Radio.Group
            options={[
              {
                label: "Aktif",
                value: true,
              },
              {
                label: "Pasif",
                value: false,
              },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
